import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Insight = React.lazy(async () => ({
    default: (await import('@oc/insight/module')).InsightModule
}))

export function InsightComponent() {
    return <SuspenseWhileLoading LazyComponent={Insight} />
}
